import SEO from "@/components/SEO";
import { PageHero, Reveal, CTABand } from "@/components/Ui";

const sections = [
  {
    title: "Éditeur du site",
    content: [
      "DMZ Normandie — Entreprise individuelle",
      "SIRET : 93071717800014",
      "Adresse : 7 rue Jean de la Fontaine, 27000 Évreux, France",
      "Téléphone : 07 45 04 91 89",
      "E-mail : dmznormandie@gmail.com",
    ],
  },
  {
    title: "Directeur de la publication",
    content: ["Alper Donmez"],
  },
  {
    title: "Hébergement",
    content: ["Les informations complètes de l'hébergeur du site sont en cours de mise à jour."],
  },
  {
    title: "Propriété intellectuelle",
    content: ["L'ensemble des contenus du site — textes, photographies, logo, éléments graphiques et structure — appartient à DMZ Normandie ou est utilisé avec autorisation. Toute reproduction ou réutilisation sans accord écrit préalable est interdite."],
  },
  {
    title: "Responsabilité",
    content: ["DMZ Normandie s'efforce de fournir des informations exactes et régulièrement mises à jour. Les contenus du site sont fournis à titre informatif et ne remplacent pas une étude technique ou un devis personnalisé."],
  },
  {
    title: "Contact",
    content: ["Pour toute question concernant le site ou ses contenus, contactez DMZ Normandie par téléphone au 07 45 04 91 89 ou par e-mail à dmznormandie@gmail.com."],
  },
];

export default function MentionsLegales() {
  return (
    <>
      <SEO
        title="Mentions légales | DMZ Normandie"
        description="Mentions légales du site DMZ Normandie, entreprise individuelle de maçonnerie et rénovation à Évreux, Bernay et en Normandie."
        path="/mentions-legales"
      />
      <PageHero title="Mentions légales" subtitle="Informations légales relatives au site et à son éditeur, DMZ Normandie." />
      <section className="py-20 lg:py-28" data-testid="mentions-legales-page">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-10">
          {sections.map((section, i) => (
            <Reveal key={section.title} className="card-dark p-8" data-testid={`mentions-section-${i}`}>
              <h2 className="font-serif-display font-light text-3xl text-[#F5F5F0] mb-5">{section.title}</h2>
              <div className="space-y-3">
                {section.content.map((line) => (
                  <p key={line} className="text-sm md:text-base font-light text-zinc-400 leading-relaxed">{line}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}
